import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutDefaultModule, LayoutDefaultOptions } from '@delon/theme/layout-default';
import { environment } from '@env/environment';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { Subscription } from 'rxjs';
import { TenantStateService } from 'src/app/services/tenant-state.service';
import { CustomSidebarNavComponent } from 'src/app/shared/components/custom-sidebar-nav/custom-sidebar-nav.component';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { HeaderTenantComponent } from './widgets/tenant.component';
import { HeaderUserComponent } from './widgets/user.component';
import { HeaderVersionInfoComponent } from './widgets/version-info.component';

@Component({
  selector: 'layout-basic',
  template: `
    <layout-default [options]="options" [content]="contentTpl" [customError]="null" [nav]="navTpl" [testId]="'layout-basic'">
      <layout-default-header-item direction="left" hidden="pc" [testId]="'header-search-mobile'">
        <div layout-default-header-item-trigger (click)="searchToggleStatus = !searchToggleStatus" [testId]="'search-toggle-trigger'">
          <nz-icon nzType="search" [testId]="'search-icon'" />
        </div>
      </layout-default-header-item>
      <layout-default-header-item direction="right" [testId]="'header-tenant-item'">
        <header-tenant [testId]="'header-tenant'" />
      </layout-default-header-item>
      <layout-default-header-item direction="right" [testId]="'header-user-item'">
        <header-user [testId]="'header-user'" />
      </layout-default-header-item>
      <ng-template #contentTpl>
        <router-outlet [testId]="'main-content'" />
      </ng-template>
      <ng-template #navTpl let-collapsed="collapsed">
        <custom-sidebar-nav [collapsed]="collapsed" />
      </ng-template>
    </layout-default>

    <!-- 版本信息組件 -->
    <header-version-info #versionInfo [testId]="'version-info'" />
  `,
  imports: [
    RouterOutlet,
    LayoutDefaultModule,
    NzIconModule,
    NzMenuModule,
    NzDropDownModule,
    NzAvatarModule,
    HeaderUserComponent,
    HeaderTenantComponent,
    HeaderVersionInfoComponent,
    CustomSidebarNavComponent,
    TestIdDirective
  ],
  styles: [
    `
      :host ::ng-deep .alain-default {
        height: 100%;
        overflow: hidden !important;
        .alain-default__header {
          left: 200px;
          width: calc(100% - 200px);
          height: 52px;
          background-color: #fff;
          box-shadow: none;
          transition:
            left 0.2s,
            width 0.2s;
        }
        .alain-default__nav:first-child {
          margin-right: 5px;
          margin-left: -20px;
        }
        &.alain-default__collapsed .alain-default__header {
          left: 64px;
          width: calc(100% - 64px);
        }
        // 添加响应式处理
        @media (max-width: 768px) {
          .alain-default__header {
            left: 0 !important;
            width: 100% !important;
            position: relative !important;
          }
          .alain-default__content,
          &.alain-default__fixed:not(.alain-default__hide-header) .alain-default__content {
            margin-top: 0 !important;
          }
          &.alain-default__collapsed .alain-default__header {
            left: 0 !important;
            width: 100% !important;
          }
          .alain-default__aside {
            position: fixed !important;
            left: 0;
            top: 0 !important;
            height: 100vh;
            z-index: 1001;
            transform: translateX(0);
            transition: transform 0.2s ease;
          }
          &.alain-default__collapsed .alain-default__aside {
            transform: translateX(-100%);
          }
        }
        @media (max-width: 576px) {
          .alain-default__header {
            left: 0 !important;
            width: 100% !important;
            position: relative !important;
            height: auto;
            min-height: 52px;
          }
          .alain-default__content,
          &.alain-default__fixed:not(.alain-default__hide-header) .alain-default__content {
            margin-top: 0 !important;
          }
        }
        .alain-default__aside {
          top: -64px;
          background-color: #2c4a6c;
        }
        .alain-default__header-logo {
          display: none;
        }
        .alain-default__nav-item,
        .alain-default__nav nz-badge {
          color: #000000;
        }

        .alain-default__aside-inner {
          background-color: #2c4a6c;
        }

        /* 使用正确的选择器定位侧边栏菜单项 */
        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child,
        .alain-default__nav ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child {
          height: 52px !important;
          line-height: 52px !important;
          display: flex !important;
          justify-content: center !important;
          position: relative;
          margin: 0 !important;
          border-bottom: 1px solid rgb(255 255 255 / 14%);
          cursor: pointer !important;

          /* Logo 图片区域 */
          &::before {
            content: '';
            display: inline-block;
            width: 55px;
            height: 28px;
            background-image: url('/assets/images/logo/Aile-logo.svg');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 8px;
            vertical-align: middle;
            cursor: pointer;
            position: relative;
            z-index: 10;
          }

          /* 添加懸停效果 */
          &:hover {
            background-color: rgb(255 255 255 / 8%);
          }

          span {
            color: #ffffff;
            font-size: 20px;
            pointer-events: none; /* 防止文字阻挡点击事件 */
          }
        }

        &.alain-default__collapsed .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child,
        &.alain-default__collapsed .alain-default__nav ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;

          &::before {
            display: inline-block !important;
            width: 32px;
            height: 32px;
            margin-right: 0;
            background-image: url('/assets/images/logo/Aile-collapsed-icon.svg');
            background-size: contain;
          }
        }

        .sidebar-nav__item-link {
          padding: 0 0 0 8px;
          color: rgb(255 255 255 / 88%);
        }

        .sidebar-nav__item-text,
        .sidebar-nav__item-icon,
        .sidebar-nav__sub-arrow {
          color: inherit;
        }

        /* 一级菜单项：展开和收合都保持一致的父项高度与间距 */
        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li {
          margin: 10px 0 !important;
        }

        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li > .sidebar-nav__item-link {
          min-height: 40px;
          line-height: 40px;
          border-radius: 4px;
          transition:
            background-color 0.2s ease,
            color 0.2s ease;
        }

        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li > .sidebar-nav__item-link:hover {
          background: rgb(255 255 255 / 8%);
          color: #ffffff;
        }

        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__selected > .sidebar-nav__item-link {
          background: rgb(111 154 201 / 0.78);
          color: #ffffff;
          box-shadow: inset 0 0 0 1px rgb(255 255 255 / 8%);
        }

        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:not(.sidebar-nav__open) {
          height: 40px !important;

          /* 统一的选中状态样式 */
          &.sidebar-nav__selected {
            .sidebar-nav__item-link {
              background: rgb(111 154 201 / 0.78) !important;
              color: #ffffff !important;
              box-shadow: inset 0 0 0 1px rgb(255 255 255 / 8%);
            }

            .sidebar-nav__item-text {
              color: #ffffff !important;
            }

            nz-icon {
              color: #ffffff !important;
            }

            span {
              color: #ffffff !important;
            }
          }
        }

        .alain-default__aside-inner .sidebar-nav__sub {
          display: none;
          padding-left: 0 !important;
          margin: 4px 0 0 !important;
        }

        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__open {
          height: auto !important;
          line-height: normal !important;
          overflow: visible !important;
        }

        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__open > .sidebar-nav__sub {
          display: block;
        }

        .alain-default__aside-inner .sidebar-nav__sub > .sidebar-nav__item {
          height: 34px !important;
          line-height: 34px !important;
          margin: 0 !important;
        }

        .alain-default__aside-inner .sidebar-nav__sub .sidebar-nav__item-link {
          padding-left: 40px !important;
          font-size: 14px;
          font-weight: 500;
          border-radius: 4px;
          color: rgb(255 255 255 / 72%);
        }

        .alain-default__aside-inner .sidebar-nav__sub .sidebar-nav__item.sidebar-nav__selected .sidebar-nav__item-link {
          background: rgb(111 154 201 / 0.7) !important;
          color: #ffffff !important;
        }

        .alain-default__aside-inner .sidebar-nav__sub-arrow {
          margin-left: auto;
          color: rgb(255 255 255 / 45%);
          transition: transform 0.2s ease;
        }

        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__open > .sidebar-nav__item-link .sidebar-nav__sub-arrow {
          transform: rotate(90deg);
        }

        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__open > .sidebar-nav__item-link {
          background: rgb(255 255 255 / 8%);
          color: #ffffff;
        }

        .alain-default__search {
          border: 1px solid #d9d9d9;
          margin: 0;
        }
        .alain-default__search ::placeholder {
          color: #d9d9d9;
        }
        .alain-default__nav-item--collapse nz-icon {
          font-size: 20px !important;
        }
      }
      /* 个人租户主题样式 */
      :host.person-tenant-theme ::ng-deep .alain-default {
        .alain-default__aside,
        .alain-default__aside-inner {
          background-color: #ffffff !important;
        }

        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child,
        .alain-default__nav ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child {
          border-bottom: 1px solid #f0f0f0;

          &:hover {
            background-color: #fafafa;
          }

          span {
            color: #1677ff;
          }
        }

        .sidebar-nav__item-link {
          color: rgb(0 0 0 / 88%);
        }

        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li > .sidebar-nav__item-link:hover,
        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__open > .sidebar-nav__item-link {
          background: #f5faff;
          color: #1677ff;
        }

        .alain-default__aside-inner .sidebar-nav__item.sidebar-nav__selected > .sidebar-nav__item-link,
        .alain-default__aside-inner
          ul.sidebar-nav:not(.sidebar-nav__sub)
          > li:not(.sidebar-nav__open).sidebar-nav__selected
          .sidebar-nav__item-link {
          background: #e6f4ff !important;
          color: #1677ff !important;
          box-shadow: none;
        }

        .alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:not(.sidebar-nav__open).sidebar-nav__selected {
          .sidebar-nav__item-text,
          nz-icon,
          span {
            color: #1677ff !important;
          }
        }

        .alain-default__aside-inner .sidebar-nav__sub .sidebar-nav__item-link {
          color: rgb(0 0 0 / 65%);
        }

        .alain-default__aside-inner .sidebar-nav__sub .sidebar-nav__item.sidebar-nav__selected .sidebar-nav__item-link {
          background: #e6f4ff !important;
          color: #1677ff !important;
        }

        .alain-default__aside-inner .sidebar-nav__sub-arrow {
          color: rgb(0 0 0 / 45%);
        }
      }
      /* 官方租户主题样式 */
      :host.official-tenant-theme ::ng-deep .alain-default {
        .alain-default__aside {
          background-color: #262626 !important;

          .alain-default__aside-inner {
            background-color: #262626 !important;

            /* 菜单项文字和图标颜色 */
            ul li {
              color: #ffffff !important;

              a {
                color: #ffffff !important;
              }

              nz-icon {
                color: #ffffff !important;
              }

              span {
                color: #ffffff !important;
              }

              /* 悬停效果 */
              &:hover {
                background-color: rgba(255, 255, 255, 0.1) !important;
              }

              /* 官方租户也使用相同的选中状态样式 */
              &.sidebar-nav__selected {
                background-color: #e6f7ff !important;

                .sidebar-nav__item-link {
                  background-color: #e6f7ff !important;
                }

                .sidebar-nav__item-text {
                  color: #1890ff !important;
                }

                nz-icon {
                  color: #1890ff !important;
                }

                span {
                  color: #1890ff !important;
                }
              }
            }

            /* Logo区域样式调整 */
            ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child {
              border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;

              span {
                color: #ffffff !important;
              }
            }

            .sidebar-nav__item--official-bottom > .sidebar-nav__item-link {
              background: rgba(255, 255, 255, 0.08) !important;
            }

            .sidebar-nav__item--official-bottom > .sidebar-nav__item-link:hover {
              background: rgba(255, 255, 255, 0.12) !important;
            }

            .sidebar-nav__item--official-bottom > .sidebar-nav__item-link .sidebar-nav__sub-arrow::before,
            .sidebar-nav__item--official-bottom > .sidebar-nav__item-link .sidebar-nav__sub-arrow::after {
              background: #ffffff !important;
              background-image: none !important;
              opacity: 1 !important;
            }
          }
        }
      }
    `
  ],
  host: {
    '(click)': 'onHostClick($event)'
  }
})
export class LayoutBasicComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('versionInfo') versionInfo!: HeaderVersionInfoComponent;

  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  private tenantStateService = inject(TenantStateService);
  private logoClickListener?: () => void;
  private tenantSubscription?: Subscription;

  // 当前租户信息
  private currentTenant: any = null;

  ngOnInit(): void {
    // 订阅租户状态变化
    this.tenantSubscription = this.tenantStateService.currentTenant$.subscribe(tenantId => {
      if (tenantId) {
        // 当租户ID变化时，重新获取完整的租户信息
        this.updateTenantInfo(tenantId);
      } else {
        this.currentTenant = null;
        this.applyTenantTheme();
      }
    });
  }

  ngAfterViewInit(): void {
    // 使用 requestAnimationFrame 确保在下一个渲染周期执行
    requestAnimationFrame(() => {
      this.addLogoClickListener();
      this.initGlobalWebchat();
      // 初始主题应用会在 ngOnInit 的订阅中处理
    });
  }

  private initGlobalWebchat(): void {
    const w = window as any;
    const scriptId = 'AileWebChat';
    if (w.__AILE_ADMIN_WEBCHAT_INJECTED__) return;
    if (document.getElementById(scriptId)) {
      return;
    }

    if (typeof w[scriptId] === 'undefined') {
      const queueFn: any = function () {
        (queueFn.q = queueFn.q || []).push(arguments);
      };
      queueFn.l = Date.now();
      w[scriptId] = queueFn;
    }
    w.AileWebChatConfig = {
      hostUrl: 'https://aile-webchat-prod.web.app/chatroom',
      id: '69a69909e8e0f229de3b7c5f',
      tenantCode: '84459043-00',
      action: 'service',
      position: 'bottom-right',
      bottomOffset: 20,
      rightOffset: 20,
      icon: 'https://newaile.prod.aile.cloud/base/attachment/v1/file/download/t/d/594a5145af8d7eb777be252efcb0e422b54757bd9b7e3525f8cd79dab46a3a8c0f246a8602fe967ff197b3d9bc5b7ba1',
      monitorConfigUrl: 'https://newaile.prod.aile.cloud/tenant/servicenumber/webchat/v1/monitor-rules/69a69909e8e0f229de3b7c5f',
      monitorRequestMethod: 'POST',
      buttonSize: 'large',
      loginMode: 'anonymous',
      animation: 'none',
      badgeColor: '#1890ff',
      onLoad: function (res: any) {
        console.log('AileWebChat onLoad', res);
      },
      onError: function (err: any) {
        console.error('AileWebChat onError', err);
      }
    };

    const js = this.renderer.createElement('script');
    js.id = scriptId;
    js.src = 'https://aile-admin-prod.web.app/assets/webchat-sdk/aile-webchat-loader.js?v=1775787856410';
    js.async = true;
    js.onload = () => {
      w.__AILE_ADMIN_WEBCHAT_INJECTED__ = true;
      console.log('AileWebChat loader loaded');
    };
    js.onerror = () => {
      w.__AILE_ADMIN_WEBCHAT_INJECTED__ = false;
      console.error('AileWebChat loader failed');
      if (js.parentNode) {
        js.parentNode.removeChild(js);
      }
    };
    this.renderer.appendChild(document.body, js);
  }

  // 更新租户信息
  private updateTenantInfo(tenantId: string): void {
    // 从 localStorage 获取完整的租户信息
    const tenantStr = localStorage.getItem('current_tenant');
    if (tenantStr) {
      try {
        const tenant = JSON.parse(tenantStr);
        if (tenant.id === tenantId) {
          this.currentTenant = tenant;
          this.applyTenantTheme();
        }
      } catch (error) {}
    }
  }

  // 根据租户类型应用主题
  private applyTenantTheme(): void {
    this.renderer.removeClass(this.el.nativeElement, 'official-tenant-theme');
    this.renderer.removeClass(this.el.nativeElement, 'person-tenant-theme');

    if (this.currentTenant?.type === 'Official') {
      this.renderer.addClass(this.el.nativeElement, 'official-tenant-theme');
      return;
    }

    if (this.currentTenant?.type === 'Person') {
      this.renderer.addClass(this.el.nativeElement, 'person-tenant-theme');
    }
  }

  ngOnDestroy(): void {
    // 清理事件监听器
    if (this.logoClickListener) {
      this.logoClickListener();
    }

    // 清理租户订阅
    if (this.tenantSubscription) {
      this.tenantSubscription.unsubscribe();
    }
  }

  // 使用事件委托，性能更优
  onHostClick(event: Event): void {
    const target = event.target as Element;

    // 检查是否点击了 logo 区域
    const logoElement = target.closest(
      '.alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child, .alain-default__nav ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child'
    );

    if (logoElement) {
      event.preventDefault();
      event.stopPropagation();
      this.showVersionInfo();
    }
  }

  private addLogoClickListener(): void {
    // 简化的实现，只使用最可能的选择器
    const logoElement = this.el.nativeElement.querySelector(
      '.alain-default__aside-inner ul.sidebar-nav:not(.sidebar-nav__sub) > li:first-child'
    );

    if (logoElement) {
      // 使用 Renderer2 添加事件监听器，并保存清理函数
      this.logoClickListener = this.renderer.listen(logoElement, 'click', (event: Event) => {
        event.preventDefault();
        event.stopPropagation();
        this.showVersionInfo();
      });
    }
  }

  showVersionInfo(): void {
    if (this.versionInfo) {
      this.versionInfo.show();
    }
  }

  options: LayoutDefaultOptions = {};
  searchToggleStatus = false;
  showSettingDrawer = !environment.production;
}
